import { getQuickLoadRequest, removeQuickLoadRequest } from './quickLoad';

export const withQuickLoad = <TResponse>({
  namespace,
  entityName,
  cacheKey,
  baseLoad,
}: {
  namespace: string;
  entityName: string;
  cacheKey: string;
  baseLoad: () => Promise<TResponse>;
}) => {
  const quickLoadRequest = getQuickLoadRequest({
    namespace,
    entityName,
    cacheKey,
  }) as ReturnType<typeof baseLoad> | undefined;

  if (!quickLoadRequest) {
    return baseLoad();
  }

  return quickLoadRequest
    .then((result) => {
      removeQuickLoadRequest({ namespace, entityName, cacheKey });

      return result as TResponse;
    })
    .catch(() => {
      removeQuickLoadRequest({ namespace, entityName, cacheKey });

      return baseLoad();
    });
};
